import React from 'react';
import PropTypes from 'prop-types';
import css from './Legacy.css';
import { Label } from '../../components/widgets';

const Legacy = ({ label = 'STATIC.PAGES.MANAGE_LINKS.LEGACY_LINKS_TEXT', subLabel = '' }) => {
    return (
        <div className={css.legacy}>
            <Label type="h3" text={label} />
            {subLabel ? <Label type="h3" text={subLabel} /> : null}
        </div>
    );
};

Legacy.propTypes = {
    label: PropTypes.string,
    subLabel: PropTypes.string,
};

export default Legacy;
